import React, { useCallback } from 'react';
import Modal from 'react-modal';
import { GrClose } from 'react-icons/gr';
import SigIn from '../SignIn';
import SignUp from '../SignUp';
import { useModal } from '../../hooks/modal';
import { AuthProvider } from '../../hooks/auth';
import { useRegister } from '../../hooks/register';
import { CloseIcon, modalStyles } from './styles';

const ModalSign: React.FC = () => {
  const { modalData, handleModal } = useModal();
  const { step } = useRegister();
  const { action } = modalData;

  const closeModal = useCallback(() => {
    handleModal({ isOpen: false, action: '' });
  }, [handleModal]);

  return (
    <Modal
      id="Modal"
      isOpen={modalData?.isOpen}
      onRequestClose={closeModal}
      shouldCloseOnOverlayClick={false}
      style={modalStyles(action === 'signup' ? step : 'signin')}
      contentLabel="Sign Modal"
    >
      {step !== 'registered' && (
        <CloseIcon onClick={closeModal}>
          <GrClose size={24} />
        </CloseIcon>
      )}
      {action === 'signin' && (
        <AuthProvider>
          <SigIn />
        </AuthProvider>
      )}
      {action === 'signup' && <SignUp />}
    </Modal>
  );
};

export default ModalSign;
